import {get} from "lodash"
import {iconNames} from 'components/icon'
import {getPathForQuote} from "helpers/navigation"

export const NotificationMessageType = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
}

export const NotificationUIDismissStyle = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
  DISABLED: 'DISABLED',
}

export const isUserNotification = (user, notification) => {
  return notification.messageType === NotificationMessageType.USER
}

export const isSystemNotification = (user, notification) => {
  return notification.messageType === NotificationMessageType.SYSTEM
}

export const shouldHideNotificationAutomatically = (user, notification) => {
  return notification.uiDismissStyle === NotificationUIDismissStyle.AUTOMATIC
}

export const isNotificationDismissable = (user, notification) => {
  return notification.uiDismissStyle !== NotificationUIDismissStyle.DISABLED
}

export const getIconNameForNotification = (user, notification) => {
  return getIconNameForObjectType(notification.objectType)
}

export const getIconNameForObjectType = (objectType) => {
  switch (objectType) {
    case 'Activity':
      return iconNames.activity
    case 'Approval':
      return iconNames.approvals
    case 'Contact':
      return iconNames.contact
    case 'ContactList':
      return iconNames.contactList
    case 'Company':
      return iconNames.company
    case 'Order':
      return iconNames.order
    case 'Opportunity':
      return iconNames.opportunity
    default:
      return iconNames.notifications
  }
}

export const getIconNameForSeverity = (user, notification) => {
  switch (getSeverityLevel(user, notification)) {
    case 'INFORMATION':
      return iconNames.info
    case 'WARNING':
      return iconNames.warning
    case 'ERROR':
    default:
      return iconNames.alert
  }
}

export const getSeverityLevel = (user, notification) => {
  return notification.severity
}

export const getPathForApprovalNotification = approval => {
  const orderId = get(approval, 'orderId')
  const companyId = get(approval, 'order.companyId')
  const contactId = get(approval, 'order.contactId')
  return getPathForQuote(orderId, companyId, contactId, 'approvals')
}
